
import { Vue, Component, Prop } from 'vue-property-decorator'
import { moneyFormat } from '@/utils/util'

@Component
export default class OrderListCard extends Vue {
  @Prop({default: {}}) cards?: any //卡变展示数据
  @Prop({default: {}}) CardsType?: any //卡变展示字段信息
  @Prop({default: 1}) type?: number // 是否展示底部下单时间
  @Prop({default: 0}) orderType?: number  // 卡片类型
  @Prop({default: ''}) topLeft?: string // 卡片头部左边字符串

  moneyFormat = moneyFormat

  get colors () {
    let color = '#333333'
    switch (this.cards.orderStatusName) {
      case '待收货确认':
        color = '#5B8FF9'
        break
      case '已完成':
        color = '#0FCE8B'
        break
      case '待订单审核':
        color = '#FF9F00'
        break
    }
    return color
  }
}
